import { Component, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { BooleanCheckComponent } from 'app/pages/A2-utils/grid-components/boolean-check/boolean-check.component';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { PaginatorCustomService } from '../paginator-custom/paginator-custom.service';
import { _currencyFormat } from '../trip2-query-builder/utils/helpers';
import { IFormData, MyTripsGridService } from './my-trips-grid.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { BtnsForGridService } from '../btns-for-grid/btns-for-grid.service';
import { getSelectNodeAfterFilter } from '../helpers';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { BilledService } from 'app/pages/billing-general/billed/billed.service';
import { GridLayoutStore, moduleActionIdOf } from '../grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-my-trips-grid',
  templateUrl: './my-trips-grid.component.html',
  styleUrls: ['./my-trips-grid.component.scss']
})
export class MyTripsGridComponent extends ParentModule implements OnInit, OnDestroy {

  @ViewChild('modalExportReservation') modalExportReservation: T2CardComponent;
  gridOptions: GridOptions;
  subscriptions: Subscription[] = [];
  isOpenAppRidersCreate: boolean;
  tripData: any;
  formData: IFormData;
  dataCurrentModule: any = {};
  constructor(
    private myTripsGridService: MyTripsGridService,
    private paginatorCustomService: PaginatorCustomService,
    private btnsForGridService: BtnsForGridService,
    protected dataProcessingService: DataProcessingService,
    protected Inject: Injector,
    private billedService: BilledService,
    private layoutStore: GridLayoutStore,
  ) {
    super('app-billed', Inject);
    this.initGrid();
  }

  ngOnInit() {
    this.observables();
    this.initLayoutMenu();
  }

  observables() {
    this.subscriptions.push(
      this.myTripsGridService.dataForGrid$.subscribe((data: any) => {
        if (data && this.gridOptions.api) {
          this.gridOptions.api.setRowData(data);
          const selectedRows = getSelectNodeAfterFilter(this.gridOptions);
          this.paginatorCustomService.getRowSelected(selectedRows.length);
        }
      })
    );

    this.subscriptions.push(
      this.btnsForGridService.clearFilterGrid$.subscribe((filter) => {
        if (filter && this.gridOptions.api) {
          const filterForGrid = {
            'filter': () => this.gridOptions.api.setFilterModel(null),
            'sort': () => this.gridOptions.api.setSortModel(null),
            'saveLayoutGrid': () => this.saveLayout(),
          };
          return filterForGrid[filter]();
        }
      })
    );

    this.subscriptions.push(
      this.myTripsGridService.dataForm$.subscribe((formData) => {
        if (formData && Object.keys(formData).length) {
          this.formData = formData;
        }
      })
    );

    this.subscriptions.push(
      this.dataProcessingService.reloadGrid$.subscribe((val: boolean) => {
        if (val) {
          this.loadDataToExportUpdate();
        }
      })
    );

    this.subscriptions.push(this.actions.asObservable().subscribe((res) => {
      if (res) {
        this.dataCurrentModule = res;
        this.getLayout();
      }
    }));
    this.subscriptions.push(
      this.actionsList$.subscribe(() => {
        this.disabledSaveLayout(this.isAllowedAction('MyTripsGrid'));
      })
    );
    this.subscriptions.push(
      this.billedService.exporToExcel.subscribe((res: boolean) => {
        if (res && this.gridOptions.api) {
          this.gridOptions.api.exportDataAsExcel({ sheetName: 'details', fileName: 'details' });
        }
      })
    );
  }

  formatterAmountMoney = (params: any) => {
    const value = params && params.value ? params.value : 0;
    return _currencyFormat(value);
  }

  initGrid() {
    this.gridOptions = <GridOptions>{
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      rowSelection: 'multiple',
      columnDefs: [
        {
          allowContextMenuWithControlKey: true,
          headerName: '',
          width: 30,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true
        },
        {
          headerName: 'Vehicle',
          field: 'vehiclecode',
          colId: 'vehicle',
          width: 70
        }, {
          headerName: 'Validation',
          field: 'validations',
          colId: 'errorValid',
          width: 70,
          cellRendererFramework: BooleanCheckComponent
        },
        {
          headerName: 'Trip Status',
          field: 'tripstatus',
          colId: 'status',
          width: 60
        },
        {
          headerName: 'Driver',
          field: 'drivername',
          colId: 'Driver',
          width: 150
        },
        {
          headerName: 'Last Billing Change',
          children: [
            {
              headerName: 'User',
              field: 'lastbillingfullname',
              colId: 'lastbillingfullname',
              width: 80
            },
            {
              headerName: 'Date',
              field: 'lastdateupdated',
              colId: 'lastdateupdated',
              width: 120,
              cellRenderer: (params) => {
                if (params.data.lastdateupdated) {
                  return moment(params.data.lastdateupdated).format('MM-DD-YYYY hh:mm');
                }
              }
            }
          ]
        },
        {
          headerName: 'Rider Information',
          children: [
            {
              headerName: 'Rider',
              field: 'ridername',
              colId: 'ridername',
              width: 150
            },
            {
              headerName: 'Gender',
              field: 'ridergender',
              colId: 'ridergender',
              width: 50
            },
            {
              headerName: 'Member Id',
              field: 'ridermemberid',
              colId: 'ridermemberid',
              width: 90,
              cellStyle: { textAlign: 'center' }
            },
            {
              headerName: 'DOB',
              field: 'riderdobformat',
              colId: 'riderdob',
              width: 70
            },
            {
              headerName: 'Age',
              field: 'riderage',
              colId: 'ridername',
              width: 55,
              cellStyle: { textAlign: 'right' }
            },
            {
              headerName: 'Address',
              field: 'riderstreetaddress',
              colId: 'riderstreetaddress',
              width: 180
            },
            {
              headerName: 'City',
              field: 'ridercity',
              colId: 'ridercity',
              width: 100
            },
            {
              headerName: 'Zip',
              field: 'riderzip',
              colId: 'riderzip',
              width: 50
            },
            {
              headerName: 'County',
              field: 'ridercounty',
              colId: 'ridercounty',
              width: 70
            },
            {
              headerName: 'Region',
              field: 'riderregion',
              colId: 'riderregion',
              width: 70,
              cellStyle: { textAlign: 'right' }
            },
            {
              headerName: 'Trip Duplicate',
              field: 'ishighlighted',
              colId: 'ishighlighted',
              width: 80,
              cellRendererFramework: BooleanCheckComponent
            },
          ]
        },
        {
          headerName: 'R. For Transport',
          field: 'reasontransport',
          colId: 'reasontransport',
          width: 160
        },
        {
          headerName: 'Payor',
          field: 'payor',
          colId: 'payor',
          width: 80
        },
        {
          headerName: 'Payor Authorization',
          field: 'payorauthorization',
          colId: 'payorauthorization',
          width: 100
        },
        {
          headerName: 'Service',
          field: 'servicetype',
          colId: 'service',
          width: 80
        },
        {
          headerName: 'Provider',
          field: 'company',
          colId: 'company',
          width: 80
        },
        {
          headerName: 'Provider amount',
          field: 'provideramount',
          colId: 'provideramount',
          width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: this.formatterAmountMoney
        },
        {
          headerName: 'Submission Date',
          field: 'submissiondate',
          colId: 'submissiondate',
          width: 100
        },
        {
          headerName: 'Paid Date',
          field: 'paiddate',
          colId: 'paiddate',
          width: 100
        },
        {
          headerName: 'File No',
          field: 'edifileid',
          colId: 'edifileid',
          width: 100
        },
        {
          headerName: 'File Sent Date',
          field: 'filesentdate',
          colId: 'filesentdate',
          width: 130
        },
        {
          headerName: 'Company',
          field: 'broker',
          colId: 'broker',
          width: 80
        },
        {
          headerName: 'Billing Status',
          field: 'billingstatus',
          colId: 'billingstatus',
          width: 80
        },
        {
          headerName: 'Aging',
          field: 'aging',
          colId: 'aging',
          width: 90
        },
        {
          headerName: 'Remarks',
          field: 'remarks',
          colId: 'remarks',
          width: 80
        },
        {
          headerName: 'Date',
          field: 'dateofservice',
          colId: 'date',
          width: 75
        },
        {
          headerName: 'Reservation',
          field: 'consecutive',
          colId: 'consecutive',
          width: 80
        },
        {
          headerName: 'RescueNet #',
          field: 'rescuenetnumber',
          colId: 'rescuenetnumber',
          width: 80
        },
        {
          headerName: 'Leg',
          field: 'leg',
          colId: 'leg',
          width: 50
        },
        {
          headerName: 'Appointment',
          field: 'appointmenttime',
          colId: 'appointmenttime',
          width: 80
        },
        {
          headerName: 'Total amount',
          field: 'totalamount',
          colId: 'totalamount',
          width: 100,
          cellStyle: { textAlign: 'right' },
          cellRenderer: this.formatterAmountMoney
        },
        {
          headerName: 'Millages',
          field: 'totalmiles',
          colId: 'totalmiles',
          width: 100,
          cellStyle: { textAlign: 'right' },
        },
        {
          headerName: 'Has Manual Charges',
          field: 'hasmanualcharges',
          colId: 'hasmanualcharges',
          width: 90,
          cellRendererFramework: BooleanCheckComponent
        },
        {
          headerName: 'Schedule Name',
          field: 'schedulename',
          colId: 'schedulename',
          width: 90
        },
        {
          headerName: 'Modifiers',
          field: 'modifiers',
          colId: 'modifiers',
          width: 90
        },
        {
          headerName: 'Pick-Up',
          children: [{
            headerName: 'Actual PU',
            field: 'actualpickup',
            colId: 'actualpickup',
            width: 120
          },
          {
            headerName: 'PU Time',
            field: 'pickup',
            colId: 'puTime',
            width: 120
          },
          {
            headerName: 'Address',
            field: 'triplocationpickup.streetaddress',
            colId: 'puaddresss',
            width: 120
          },

          {
            headerName: 'City',
            field: 'triplocationpickup.city',
            colId: 'puCity',
            width: 120
          },
          {
            headerName: 'ZipCode',
            field: 'triplocationpickup.zip',
            colId: 'zipcodeP',
            width: 120
          },
          {
            headerName: 'Region PU',
            field: 'triplocationpickup.region',
            colId: 'triplocationpickup.region',
            width: 70
          }
          ]
        },
        {
          headerName: 'Drop-Off',
          children: [{
            headerName: 'Actual DO',
            field: 'actualdropoff',
            colId: 'actualdropoff',
            width: 120
          },
          {
            headerName: 'Address',
            field: 'triplocationdropoff.streetaddress',
            colId: 'doaddresss',
            width: 120
          },

          {
            headerName: 'City',
            field: 'triplocationdropoff.city',
            colId: 'doCity',
            width: 120
          },
          {
            headerName: 'ZipCode',
            field: 'triplocationdropoff.zip',
            colId: 'zipD',
            width: 120
          },
          {
            headerName: 'Region DO',
            field: 'triplocationdropoff.region',
            colId: 'triplocationdropoff.region',
            width: 70
          }
          ],
        }
      ],
      onGridReady: () => {
        this.gridOptions.api.setRowData([]);
      },
      onSelectionChanged: () => {
        if (this.gridOptions.api) {
          this.paginatorCustomService.getRowSelected(this.gridOptions.api.getSelectedNodes().length);
        }
      },
      onRowDoubleClicked: (event) => {
        if (event && event.data) {
          this.tripData = event.data;
          this.modalExportReservation.open();
        }
      },
      onFilterChanged: (params) => {
        if (params && params.api) {
          this.btnsForGridService.btnDisabled({ type: 'filter', disabled: params.api['filterManager'].advancedFilterPresent });
        }
      },
      onSortChanged: () => {
        const sort = this.gridOptions.api.getSortModel();
        this.btnsForGridService.btnDisabled({ type: 'sort', disabled: sort.length ? true : false });
      }
    };
  }

  loadDataToExportUpdate() {
    const data = {
      payoridslist: this.formData.payoridslist.map((item) => { return item; }),
      initialdate: this.formData.initialdate,
      finaldate: this.formData.finaldate,
      billingstatusid: this.formData.billingstatusid,
      formid: null,
      tripId: this.tripData.tripid
    };
    this.dataProcessingService.loadTripsToExportByTripId(data).subscribe((res) => {
      if (res && res.tripid) {
        const row = this.gridOptions.api.getRowNode((res.tripid).toString());
        row.setData(res);
      }
    });
  }

  getRowNodeId = (data) => {
    if (data && data.tripid) {
      return data.tripid;
    }
  }

  getLayout(): void {
    const moduleId = this.dataCurrentModule.moduleid;
    this.subscriptions.push(
      this.myTripsGridService.getRoleActionByModule(moduleId).subscribe(
        data => {
          data.forEach((val: any) => {
            if (val.action.description === 'MyTripsGrid' && val.layout) {
              this.gridOptions.columnApi.setColumnState(JSON.parse(val.layout.config));
            }
          });
        }
      ));
  }

  saveLayout(): void {
    if (this.gridOptions.columnApi.getColumnState().length) {
      const MODULE_ACTION_ID = this.dataCurrentModule.actions.MyTripsGrid.moduleactionid;
      const stringLayout = JSON.stringify(this.gridOptions.columnApi.getColumnState());
      const data = { moduleactionid: MODULE_ACTION_ID, config: stringLayout };
      this.btnsForGridService.saveLayoutGrid(data);
    }
  }

  get titleModal(): string {
    if (this.tripData) {
      const { consecutive, leg, ridername } = this.tripData;
      if (consecutive && leg && ridername) {
        return `Reservation # ${consecutive} - Leg ${leg} - ${ridername}`;
      }
    }
  }

  disabledSaveLayout(disabledBtn): void {
    this.btnsForGridService.btnDisabled({ type: 'layout', disabled: disabledBtn });
  }

  private initLayoutMenu() {
    this.subscriptions.push(this.layoutStore.follow(this.actionsList$, () => ({
      grid: this.gridOptions,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, 'MyTripsGrid'),
      title: 'Billed Details'
    })));
  }

  ngOnDestroy() {
    this.dataProcessingService.getReloadGrid(false);
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/my-trips-grid/my-trips-grid.component.ts